import type { Company } from "@/lib/hooks/api/companies";

export type CompanyRow = Company & Record<string, unknown>;

export interface CompanyDetailsTabProps {
  companyId?: string | null;
  companyData?: CompanyRow | null;
  companyName?: string | null;
  embedded?: boolean;
  onViewFullCompany?: (companyId: string) => void;
  nestedCompanyData?: CompanyRow | null;
  nestedCompanyId?: string | null;
  ticketId?: string | null;
}

export function companyWithId(v: unknown): CompanyRow | null {
  if (!v || typeof v !== "object") return null;
  const o = v as { id?: string };
  return typeof o.id === "string" && o.id ? (v as CompanyRow) : null;
}

export function formatAddress(c: CompanyRow): string | null {
  const parts = [c.address, c.city, c.state, c.zip_code, c.country].filter(
    (x) => typeof x === "string" && x.trim().length > 0,
  ) as string[];
  return parts.length ? parts.join(", ") : null;
}

function trimmedString(v: unknown): string | null {
  return typeof v === "string" && v.trim() ? v.trim() : null;
}

export function asStringId(value: unknown): string | null {
  return typeof value === "string" && value ? value : null;
}

export function getCompanyWebsite(c: CompanyRow): string | null {
  return trimmedString(c.website);
}

export function getCompanyPhone(c: CompanyRow): string | null {
  return trimmedString(c.organization_phone);
}

export function getCompanyIndustry(c: CompanyRow): string | null {
  return trimmedString(c.industry);
}
